import { ApiOutlined, BarChartOutlined, HomeOutlined, TeamOutlined, ThunderboltOutlined, UserOutlined } from '@ant-design/icons';
import type { AdminRole } from '../store/auth';

export interface NavItem {
  key: string;
  to: string;
  label: string;
  icon: React.ReactNode;
  requireRole?: AdminRole;
}

export interface NavGroup {
  key: string;
  label: string;
  items: NavItem[];
}

export const NAV_GROUPS: NavGroup[] = [
  {
    key: 'ops',
    label: '运营管理',
    items: [
      { key: 'dashboard', to: '/dashboard', label: '仪表盘', icon: <HomeOutlined /> },
      { key: 'tenants', to: '/tenants', label: '租户管理', icon: <TeamOutlined /> },
      { key: 'usage', to: '/usage', label: '用量管理', icon: <BarChartOutlined /> },
    ],
  },
  {
    key: 'models',
    label: '模型服务',
    items: [
      { key: 'model-providers', to: '/model-providers', label: '模型管理', icon: <ApiOutlined /> },
    ],
  },
  {
    key: 'system',
    label: '系统管理',
    items: [
      { key: 'jobs', to: '/jobs', label: '任务监控', icon: <ThunderboltOutlined /> },
      { key: 'admins', to: '/admins', label: '用户管理', icon: <UserOutlined />, requireRole: 'admin' },
    ],
  },
];

export const NAV: NavItem[] = NAV_GROUPS.flatMap((g) => g.items);

export function filterNavGroups(groups: NavGroup[], role?: AdminRole | null): NavGroup[] {
  return groups
    .map((group) => ({
      ...group,
      items: group.items.filter((n) => !n.requireRole || n.requireRole === role),
    }))
    .filter((group) => group.items.length > 0);
}

export function isNavActive(to: string, pathname: string): boolean {
  if (to === '/usage') return pathname === '/usage' || pathname.startsWith('/usage/');
  if (to === '/tenants') return pathname === '/tenants' || pathname.startsWith('/tenants/');
  if (to === '/model-providers') return pathname === '/model-providers' || pathname.startsWith('/model-providers/');
  return pathname === to || pathname.startsWith(`${to}/`);
}
